// @flow
import { logIn } from './actions';

export default {
    [logIn.toString()]: [
        {
            condition: ({ manualLogin }) => !!manualLogin,
            event: () => 'Event 1',
            values: payload => ({
                eVar1: payload.user.username
            })
        }
    ]
};



// WEBPACK FOOTER //
// ./src/core/state/application/trackers.js